import { createAsyncThunk } from "@reduxjs/toolkit";
import trackingApi from 'api/trackingApi';
import { formatQueryParams } from "helpers/format";

export const getArticleTrackings = createAsyncThunk("News Monitors", async (params: any = {}) => {
  try {
    const response = await trackingApi.articleTrackings(formatQueryParams(params))
    return response;
  } catch (error) {
    return error;
  }
});

export const getSummariesArticleTrackings = async (params: any = {}) => {
  try {
    const response = await trackingApi.summariesArticleTrackings(formatQueryParams(params))
    return response;
  } catch (error) {
    return error;
  }
};

export const downloadExcelTrackingNews = async (params: any = {}) => {
  try {
    const response = await trackingApi.downloadExcelTrackingNews(formatQueryParams(params));
    return response;
  } catch (error) {
    return error;
  }
};

export const getArticleTrackingsByNormal = async (params: any = {}) => {
  try {
    const response = await trackingApi.articleTrackings(formatQueryParams(params))
    return response;
  } catch (error) {
    return error;
  }
};

export const getTrackingLogsByNormal = async (params: any = {}) => {
  try {
    const response = await trackingApi.trackingLogs(formatQueryParams(params))
    return response;
  } catch (error) {
    return error;
  }
};

export const downloadExcelTrackingLogs = async (params: any = {}) => {
  try {
    const response = await trackingApi.downloadExcelTrackingLogs(formatQueryParams(params))
    return response;
  } catch (error) {
    return error;
  }
};

export const getTrackingSummariesLogs = async (params: any = {}) => {
  try {
    const response = await trackingApi.trackingSummariesLogs(formatQueryParams(params))
    return response;
  } catch (error) {
    return error;
  }
};